// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import CurrentMembershipController from "./current_membership_controller"
application.register("current-membership", CurrentMembershipController)
